// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202611051405/js/" + chunkId + "." + {"44":"192cdccc","225":"3e2c5616","481":"206a2fa9","486":"2205ae2b","770":"e0dbfbca"}[chunkId] + ".0.3663241618132771.chunk.js";
};